<!-- Zweck: Stellt die HTML-Struktur für shop warenkorb import ticker component im Frontend bereit. -->
@if ((show|async) && (next_cron_import_diff|async) && cfg.domainconfig.import_enabled) {
  <div class="ticker" style="cursor: help">
    @if (!(cron_import_enabled|async)) {
      <span matTooltip="Automatischer Abschluss deaktiviert">
        <svg-icon>warning</svg-icon>
      </span>
    }
    @if (!(cron_import_enabled|async)) {
      <span matTooltip="Manueller Importabschluss sollte bis {{next_cron_import_run|async}} gemacht werden">{{next_cron_import_diff|async}}</span>
    }
    @if ((cron_import_enabled|async)) {
      <span matTooltip="Nächster automatischer Importabschluss {{next_cron_import_run|async}}">{{next_cron_import_diff|async}}</span>
    }
  </div>
}
